import { render, staticRenderFns } from "./SetupAccount.vue?vue&type=template&id=6f0ded11&scoped=true&"
import script from "./SetupAccount.vue?vue&type=script&lang=js&"
export * from "./SetupAccount.vue?vue&type=script&lang=js&"
import style0 from "./SetupAccount.vue?vue&type=style&index=0&id=6f0ded11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0ded11",
  null
  
)

export default component.exports